import { promiseAction } from '../../utils/store';

export const KEYWORDS_ACTION_TYPES = {
  LOAD_KEYWORDS: 'keywords/LOAD_KEYWORDS',
  DELETE_KEYWORDS: 'keywords/DELETE_KEYWORDS',
  EDIT_KEYWORDS: 'EDIT_KEYWORDS',
  CREATE_KEYWORDS: 'CREATE_KEYWORDS',
};


export const loadKeyWords = promiseAction(KEYWORDS_ACTION_TYPES.LOAD_KEYWORDS);

export const deleteKeywords = promiseAction(KEYWORDS_ACTION_TYPES.DELETE_KEYWORDS);

export const editKeyWords = promiseAction(KEYWORDS_ACTION_TYPES.EDIT_KEYWORDS);

export const createKeyWord = promiseAction(KEYWORDS_ACTION_TYPES.CREATE_KEYWORDS);